import { render, staticRenderFns } from "./BillingPlanDetailsPanel.vue?vue&type=template&id=707b3d65&scoped=true"
import script from "./BillingPlanDetailsPanel.vue?vue&type=script&lang=js"
export * from "./BillingPlanDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./BillingPlanDetailsPanel.vue?vue&type=style&index=0&id=707b3d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b3d65",
  null
  
)

export default component.exports